var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("OA审批-调岗申请")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "680px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "padding": "40px 60px",
      "overflow-x": "hidden"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#006E4B",
      "font-weight": "900",
      "font-size": "20px"
    }
  }, [_vm._v("| ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("调岗信息")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #DADADA",
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "150px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "组织架构:",
      "prop": "name"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.editData.organize_name) + "\n                        ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "城市:",
      "prop": "name"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.editData.city_id) + "\n                        ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "调岗人:",
      "prop": "name"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.editData.staff_name) + "\n                        ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证号码:",
      "prop": "name"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.editData.staff_card) + "\n                        ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "现岗位:",
      "prop": "name"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.editData.current_post) + "\n                        ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "目标岗位:",
      "prop": "name"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.editData.target_post) + "\n                        ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "现薪酬:",
      "prop": "name"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.editData.current_pay) + "\n                        ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "目标薪酬:",
      "prop": "name"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.editData.target_salary) + "\n                        ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "调岗说明:",
      "prop": "name"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.editData.transfer_explain) + "\n                        ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#006E4B",
      "font-weight": "900",
      "font-size": "20px"
    }
  }, [_vm._v("| ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("备注信息")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #DADADA",
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注:",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "50%",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "请输入备注内容"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reviewer_state == 0),
      expression: "reviewer_state == 0"
    }]
  }, [_c('el-col', {
    staticStyle: {
      "margin": "50px 500px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['examine'].save(_vm.id, 1)
      }
    }
  }, [_vm._v("同意")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "addbtn"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['examine'].reject(_vm.id)
      }
    }
  }, [_vm._v("驳回")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('examine', {
    ref: "examine"
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-289de3f4","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/QAsp/QAsp_tgsq.vue
// module id = null
// module chunks = 